/**
 * O HTML que sai do editor para o app — o mesmo que vai para PDF, e-mail e Word.
 *
 * Dentro do editor, bordas e sombreamento das tabelas vêm do CSS do componente;
 * fora dele, esse CSS não existe. Aqui eles viram estilo em linha, e a linha de
 * cabeçalho vai para um `<thead>` — é o `<thead>` que o Word, o Chromium e os
 * geradores de PDF repetem no alto de cada página. Ao voltar para o editor, os
 * estilos em linha são ignorados e o `<thead>` é lido como linha comum: só os
 * `data-*` contam, como no formato de parágrafo.
 *
 * Determinística: a mesma entrada dá a mesma saída (o editor compara por ela
 * para saber se o conteúdo foi trocado por fora).
 */
export const COR_BORDA = '#9C9BA6';
export const COR_CABECALHO = '#EFEEF2';

export function htmlDeSaida(html: string): string {
  if (!html.includes('<table') || typeof DOMParser === 'undefined') return html;
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  doc.querySelectorAll('table').forEach((t) => {
    const bordas = t.getAttribute('data-bordas') || 'todas';
    const sombrear = t.getAttribute('data-sombrear') !== 'nao';
    const repetir = t.getAttribute('data-repetir') !== 'nao';
    t.style.borderCollapse = 'collapse';
    t.style.width = '100%';
    if (bordas === 'externas') t.style.border = `1px solid ${COR_BORDA}`;
    t.querySelectorAll<HTMLElement>('th, td').forEach((c) => {
      if (bordas === 'todas') c.style.border = `1px solid ${COR_BORDA}`;
      c.style.padding = '3pt 6pt';
      c.style.verticalAlign = 'top';
      if (c.tagName === 'TH' && sombrear) c.style.background = COR_CABECALHO;
    });
    const corpo = t.querySelector(':scope > tbody');
    if (!repetir || !corpo || t.querySelector(':scope > thead')) return;
    const cabecalho: Element[] = [];
    for (const tr of Array.from(corpo.children)) {
      const celulas = Array.from(tr.children);
      if (!celulas.length || celulas.some((c) => c.tagName !== 'TH')) break;
      cabecalho.push(tr);
    }
    if (!cabecalho.length) return;
    const thead = doc.createElement('thead');
    cabecalho.forEach((tr) => thead.appendChild(tr));
    t.insertBefore(thead, corpo);
  });
  return doc.body.innerHTML;
}
